module.exports = __webpack_public_path__ + "assets/4d1aaf4f680337a0fc01c9ccabf48dc4.png";